function dataAttribute(value) {
  if (value === false || value === void 0 || value === null) {
    return void 0;
  } else if (value === true) {
    return "";
  } else {
    return String(value);
  }
}
export {
  dataAttribute
};
//# sourceMappingURL=dataAttribute.js.map
